import {CreateUserScheduleApiPayload} from "../../../../../react-query-hooks/schedule/types";
import {CreateUserScheduleFormValues} from "../components/schedules-header/create-schedule-form/schema-validation";

export function createUserScheduleDto(
  values: CreateUserScheduleFormValues
): CreateUserScheduleApiPayload {
  return {
    name: values.scheduleName,
  };
}
